import instance from "../../api";

export const getNotificationsHistory = () => {
  return instance(true)
    .get(`/crm/notice/hist/`,)
    .then((res) => {
      return res?.data;
    });
};